import { StretchPopup } from './stretchPopup';

export class RegLoginDoublePopup {
    private static hiddenClass = 'reg-login-double-popup__hidden';

    public static init() {
        $('.reg-login-double-popup').each(function initDoublePopup() {
            const switchContainer = $(this);

            switchContainer.find('.reg-login-double-popup__to-login')
                .on('click', function switchToLogin() {
                    switchContainer
                        .find(`.${RegLoginDoublePopup.hiddenClass}`)
                        .removeClass(RegLoginDoublePopup.hiddenClass);
                    switchContainer
                        .find('.reg-login-double-popup__registration')
                        .addClass(RegLoginDoublePopup.hiddenClass);
                    StretchPopup.stretch();
                });

            switchContainer.find('.reg-login-double-popup__to-reg')
                .on('click', function switchToRegistration() {
                    switchContainer
                        .find(`.${RegLoginDoublePopup.hiddenClass}`)
                        .removeClass(RegLoginDoublePopup.hiddenClass);
                    switchContainer
                        .find('.reg-login-double-popup__login')
                        .addClass(RegLoginDoublePopup.hiddenClass);
                    StretchPopup.stretch();
                    window.$errorTooltip.hide();
                });
        });
    }
}
